/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument, RivenditoreDocument } from '@gql/graphql'
import { ContattaRivenditoreTemplate } from '@components/templates'

const ContattaRivenditorePage = ({ pagina, rivenditore }) => (
  <ContattaRivenditoreTemplate pagina={pagina} rivenditore={rivenditore} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/rivenditori/contatta/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'contatta-rivenditore-detail', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { rivenditore },
    } = await client.query({
      query: RivenditoreDocument,
      variables: {
        id: slug,
      },
      context: {
        headers,
      },
    })

    if (!rivenditore) {
      return {
        notFound: true,
      }
    }

    return {
      props: { rivenditore, pagina },
      revalidate: 60 * 20,
    }
  },
  '/rivenditori/contatta/[slug]'
)

export default ContattaRivenditorePage
